// import React, { useEffect, useState } from 'react';
// import { getFirestore } from "../../config/firebase";
// import logoWhatsapp from '../../assets/logoWhatsapp.png';
// import './whatsapp.scss';

// const WhatsAppFlotante = () => {

//     const [numerosWhatsapp, setNumerosWhatsapp] = useState([]);
//     const [mostrarWhatsapp, setMostrarWhatsapp] = useState(false);

//     useEffect(() => {
//         const db = getFirestore();
//         const vehicles = db.collection("jeep-informacion");

//         vehicles.get().then((querySnapshot) => {
//             const datosCompletos = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
//           setNumerosWhatsapp(datosCompletos[0].numeros);
//           setMostrarWhatsapp(datosCompletos[0].mostrar)
//         });

//       }, []);

//     const [open, setOpen] = useState(false);

//    if(!mostrarWhatsapp) {
//         return null;
//     }

//     return (
//         <div className="whatsapp-container">
//             <div className={open ? 'whatsapp-oculto activo' : 'whatsapp-oculto'}>
//                 {
//                     numerosWhatsapp.map((numero,index) => (
//                         numero.habilitado ? (
//                             <a href={numero.url} target="_blank" key={index} rel="noreferrer">
//                                 <img src={logoWhatsapp} alt="whatsapp" />
//                                 <span>{numero.nombre}</span>
//                             </a>
//                         ) : null

//                     ))

//                 }

//             </div>
//             <button  className='btn-whatsapp-flotante' onClick={() => setOpen(!open)}>
//                 <img src={logoWhatsapp} alt="whatsapp" />
//             </button>
//         </div>
//     );
// }
// export default WhatsAppFlotante;

import React, { useState } from "react";

import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { buildWhatsAppConsultaPageUrl } from "../../config/whatsappConfig";
import WhatsAppModal from "./WhatsAppModal";

const WhatsAppFlotante = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      await updateData(values);
      setOpen(false);
      const urlWithUtm = buildWhatsAppConsultaPageUrl();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.location.href = `https://api.whatsapp.com/send?phone=5493513743833&text=${encodedMessage}`;
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;
